import type Address from '@consumer/types/Address'
import { RedemptionMethod } from '@consumer/types/RedemptionMethod'
import type { RecipientGift, SavedRedemptionMethod } from '@consumer/types/serializers'
import { useStepper } from '@vueuse/core'
import cardMasterLogo from '@consumer/assets/images/card-with-master-card-logo-sm.png'
import type { Phone } from '@consumer/types/Phone'

export const recipientToastMessage = reactive<{
  icon?: {
    name?: any
    color?: string
  }
  message?: string
}>({})

export const resetMessage = () => {
  recipientToastMessage.message = ''
  recipientToastMessage.icon = {}
}

export const setMessage = (
  { message, icon }:
  { message: string; icon?: { name: any; color?: string } },
) => {
  recipientToastMessage.message = message
  recipientToastMessage.icon = icon
}

function getLithicFormData () {
  return {
    name: 'Giftly Card',
    description: () => {
      return 'Receive a virtual gift card by email, with the option to get a physical card by mail.'
    },
    imageUrl: cardMasterLogo,
  }
}

export const REDEMPTION_METHOD_FORM_DATA: {
  [key: string]: { name: string; description: () => string; imageUrl?: string }
} = {
  [RedemptionMethod.ACH]: {
    name: 'Bank Account',
    description: () => 'Receive funds directly to your bank account via ACH transfer.',
  },
  [RedemptionMethod.PayPal]: {
    name: 'PayPal',
    description: () => 'Receive funds to your PayPal account.',
  },
  [RedemptionMethod.PerfectGift]: {
    name: 'Visa® Card',
    description: () => 'Receive a physical Visa® gift card by mail.',
  },
  [RedemptionMethod.PerfectGiftVirtual]: {
    name: 'MasterCard® Card',
    description: () => 'Receive a virtual MasterCard® gift card by email.',
  },
  [RedemptionMethod.ColumnLithicVirtual]: getLithicFormData(),
  [RedemptionMethod.ColumnLithic]: getLithicFormData(),
}

export const stepper = useStepper([
  'ENVELOPE',
  'GREETING_CARD_REVEAL',
  'GREETING_CARD_OPEN',
  'VOICE_MEMO',
  'PHOTO_SLIDE_0',
  'PHOTO_SLIDE_1',
  'PHOTO_SLIDE_2',
  'GIFTLY_REVEAL',
  'REDEMPTION',
])

export const initialStep = (gift: RecipientGift) => {
  if (!gift.giftlyVersion || (gift.giftlyVersion < 2 && !gift.giftlyImageUrl)) {
    return 'GREETING_CARD_REVEAL'
  }
  else {
    return 'ENVELOPE'
  }
}

export interface RedemptionDetailsForm {
  redemptionMethod?: RedemptionMethod

  redemptionName?: string
  redemptionEmail?: string
  redemptionPhoneNumber?: string
  redemptionCountryCallingCode?: string
  redemptionPhoneNumberObject?: Phone
  redemptionShipPhysicalCard?: boolean

  redemptionCardBalanceUpdates?: boolean
  redemptionSmsDeliveryEnabled?: boolean
  redemptionBirthdate?: string

  bankRoutingNumber?: string
  bankName?: string
  bankAccountNumber?: string
  bankDetailsCorrectConfirmed?: boolean

  paypalEmail?: string

  mailingAddress: Address
  embossName?: string

  otp?: string

  savedRedemptionMethod?: SavedRedemptionMethod
  usedSavedRedemptionMethod?: boolean
  createAccountOnVerification?: boolean
  shareInfoWithGifter?: boolean
}
